import useWebchatVersion from 'app/hooks/useWebchatVersion';
import { ChatModuleType } from 'app/copied/models/ChatModules';
import useModule from 'app/hooks/useModule';
import { ChatVersion } from 'app/copied/constants/common';
import { ModuleItem, PillType } from 'app/services/helpCenter';
import { useNavigate } from 'react-router-dom';

import TailorSearchPills from '../../components/TailorSearchPills';
import { useSearch } from '../../hooks/useSearch';
import useTailorTracking from '../../hooks/useTailorTracking';

export default function TailorLandingPills() {
  const webchatVersion = useWebchatVersion();
  const pillsModule = useModule(ChatModuleType.Pills);
  const { setSearch } = useSearch();
  const navigate = useNavigate();
  const { captureLandingPagePillClicked } = useTailorTracking();

  const onPillClick = (pill: ModuleItem) => {
    const pillType = pill.pill_type;
    const searchText = pill.pill_data || pill.pill_text;
    if (pillType === PillType.SEARCH_TEXT && searchText) {
      setSearch(searchText);
      navigate('/tailor/search', {
        state: {
          prevPath: '/tailor',
          nextPath: '/tailor/search',
        },
      });
    } else if (pillType === PillType.VA_NODE) {
      navigate(`/virtual-assistant/pill/${pill.pill_data}/${pill.pill_text}`);
    }
    captureLandingPagePillClicked(pill);
  };

  if (!pillsModule) return null;

  return (
    <TailorSearchPills
      className={webchatVersion === ChatVersion.v4_1 ? 'mb-4' : ''}
      pills={pillsModule.items || []}
      onPillClick={onPillClick}
    />
  );
}
